const state = {
  tenant: '', // 当前租户
  currentApiServer: '', // 当前租户的API
  focusView: '', // 当前租户的视角
  openContract: null// 当前租户是否开启合同true/false
}
export default {
  state
}
